import { Link } from 'react-router-dom';

export default function PrivacyPolicy() {
  return (
    <div className="policy-container">
      <div className="policy-header">
        <h1>🔒 隐私政策</h1>
        <p className="policy-version">版本：v1.0 | 生效日期：2026年6月</p>
        <Link to="/" className="btn btn-outline btn-sm">← 返回首页</Link>
      </div>

      <div className="policy-content">
        <section>
          <h2>一、引言</h2>
          <p>
            「智伴精读」（以下简称「本应用」）尊重并保护用户的隐私。本隐私政策旨在说明本应用如何收集、使用、存储和保护您的个人信息。
          </p>
        </section>

        <section>
          <h2>二、收集的信息</h2>
          <p>本应用仅收集为提供服务所必需的最小化信息：</p>
          <ul>
            <li><strong>账户信息</strong>：邮箱地址、昵称（用于登录和身份识别）</li>
            <li><strong>学习数据</strong>：阅读进度、练习记录、学习偏好（用于个性化学习推荐）</li>
            <li><strong>设备信息</strong>：设备类型、操作系统版本（用于兼容性优化）</li>
          </ul>
        </section>

        <section>
          <h2>三、信息使用</h2>
          <p>收集的信息仅用于以下目的：</p>
          <ul>
            <li>提供和维护本应用的服务</li>
            <li>个性化用户体验和学习推荐</li>
            <li>改进应用功能和性能</li>
            <li>保障账户安全</li>
          </ul>
        </section>

        <section>
          <h2>四、信息存储</h2>
          <p>
            用户数据存储在本地设备中，通过加密方式保护。本应用不向第三方传输或出售您的个人信息。
          </p>
        </section>

        <section>
          <h2>五、用户权利</h2>
          <p>您有权：</p>
          <ul>
            <li>访问和查看您的个人信息</li>
            <li>更正或删除您的账户信息</li>
            <li>注销账户并清除所有数据</li>
          </ul>
        </section>

        <section>
          <h2>六、变更通知</h2>
          <p>
            本隐私政策可能会不定期更新。重大变更将通过应用内通知告知用户。
          </p>
        </section>

        <section>
          <h2>七、联系方式</h2>
          <p>
            如有任何隐私相关问题，请发送邮件至：privacy@aenedu.site
          </p>
        </section>
      </div>

      <div className="policy-footer">
        <p>© 2026 智伴精读 - 专注英语学习</p>
      </div>
    </div>
  );
}